module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step5_Image0.14848ffb.jpg";